import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { Capacitor } from '@capacitor/core';

sentry.init({
  dsn: environment.sentryDSN,
  environment: environment.production ? 'production' : 'development',
  integrations: [
    sentry.browserTracingIntegration(),
    sentry.replayIntegration(),
  ],
  tracePropagationTargets: [
    environment.parentApiBase,
    environment.authAPI,
    environment.licenseAPI,
    environment.materialServer,
    environment.contractServer,
    environment.questionnaireApplicationUrl,
  ],
  // Performance Monitoring
  tracesSampleRate: environment.tracesSampleRate ?? 0,
  // Session Replay
  replaysSessionSampleRate: environment.replaysSampleRate ?? 0,
  replaysOnErrorSampleRate: environment.replaysSampleRate ?? 0,
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));


if (Capacitor.isNativePlatform()) {
  document.body.classList.add('safe-area-inset');
}
